export const UPDATE_TRANSCRIPT = 'UPDATE_TRANSCRIPT';
export const LOAD_TRANSCRIPT = 'LOAD_TRANSCRIPT';
export const UPDATE_MEDIAID_TRANSCRIPT = 'UPDATE_MEDIAID_TRANSCRIPT';
export const TRANSCRIPT_SAVE = 'TRANSCRIPT_SAVE';




